/** @format */

import React from "react";
import FeatureFlag from "../featureFlag/FeatureFlag";
import { NotificationsList, selectNotifications } from "./notificationsSlice";
import { ToastContainer } from "react-bootstrap";
import { useSelector } from "react-redux";
import ToastItem from "./ToastItem";
import { useTranslation } from "react-i18next";
import { getRandomUUID } from "../resources/ResourceFunctions";

/**
        store.dispatch(
          setAddNotifications({
            date: new Date().toISOString(),
            id: "storageIssue",
            title: "Error saving to browser",
            msg:
              "There was an error saving to your browser. You may need to delete some old resources to free up space. " +
              e?.message,
            type: "danger",
          }),
        );
 */

const Notifications = () => {
  const { t: _ } = useTranslation();
  const notifications: NotificationsList = useSelector(selectNotifications());
  return (
    <FeatureFlag
      flag={["notifications", "dev"]}
      consoleMsg={_("Notifications feature is disabled.")}
    >
      <ToastContainer
        className="position-fixed p-4"
        position="bottom-end"
        style={{ zIndex: 10 }}
      >
        {notifications.map((item) => (
          <ToastItem {...item} id={item.id} key={getRandomUUID()} />
        ))}
      </ToastContainer>
    </FeatureFlag>
  );
};

export default Notifications;
